import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import DatePicker from 'react-datepicker';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class FlightReportsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      mode: 'online',
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleChangeDate (name, event) {
    var change = {};
    var full_date = this.state.date_start;
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      // Utilizo o .slice(-2) para garantir o formato com 2 dígitos.
      var full_date = ("0"+day).slice(-2) + "/" + ("0"+month).slice(-2) + "/" + year;
      change[name] = date;
    }
    this.setState(change);
    this.loadData(full_date);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var now = new Date();
      var month = (now.getMonth()) + 1;
      var year = now.getFullYear();
      var day = now.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      var reference = day + '/' + month + '/' + year;
      this.setState({loaded: 2}, this.loadData(reference));
    }
  }

  componentWillMount () {
    var today = new Date();
    var date = today.setDate(today.getDate());
    var today_str = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd

    this.setState({date_start: today_str});
  }

  loadData(reference) {
    var self = this;
    if(navigator.onLine) {
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/relatorios/voo/' + reference, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next});
          } else {
            self.setState({data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next});
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).then(() => {
          var url = config.get('api') + '/portal/relatorios/offline';
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              var storage = {
                flight_reports_index: responseJson.data.flight_reports,
              };
    
              localStorage.setItem("flight_reports_index", JSON.stringify(storage));
            }
          }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.handleMessage();
        }); });/* Overlay */
      });
    } else {
      var fr_index = [];
      if(localStorage.getItem("flight_reports_index")) {
        var flight_reports_index = JSON.parse(localStorage.getItem("flight_reports_index"));
        fr_index = flight_reports_index.flight_reports_index;
      }

      self.setState({data: fr_index});
      self.setState({overlay: {message: '', type: '', status: 'closed'}, mode: 'offline'});

    }
  }

  ActionsButtons (cell, row) {
    var url = '/relatorio/voo/editar/' + cell;

    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
      </div>
    );

    return botao;
  }

  next() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.next);
  }

  previous() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.previous);
  }

  render() {
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.mode === 'online' ?
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-xs-3">
          <button className="btn btn-primary" onClick={this.previous}><i className="fa fa-fw fa-chevron-left"></i> <span className="hidden-sm hidden-xs">{this.state.previous}</span></button>
        </div>
        <div className="col-xs-6">
          <h3 className="page-title text-center">{this.state.current}</h3>
        </div>
        <div className="col-xs-3 text-right">
          <button className="btn btn-primary" onClick={this.next}><span className="hidden-sm hidden-xs">{this.state.next}</span> <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
      <hr/>
      <h3 className="page-title pull-left">{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.titulo}</h3>
      <Link to="/relatorio/voo/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.botaoAdicionarRelatorioDeVoo}</Link>
      <div className="clearfix"></div>
      <hr/>
      <div className="clearfix"></div>
      <div className="row">
        <div className="col-md-2 col-md-offset-5">
          <div className="form-group">
            <input type="date" value={this.state.date_start} onChange={this.handleChangeDate.bind(this, 'date_start')} className="form-control" />
          </div>
        </div>
      </div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.semRelatorios}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='70'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Acoes}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Base}</TableHeaderColumn>
        <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="registration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Aeronave}</TableHeaderColumn>
        <TableHeaderColumn dataField="model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Frota}</TableHeaderColumn>
        <TableHeaderColumn dataField="client" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Cliente}</TableHeaderColumn>
        <TableHeaderColumn dataField="flight_type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.TipoDeVoo}</TableHeaderColumn>
        <TableHeaderColumn dataField="report_number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.NumeroDoRelatorio}</TableHeaderColumn>
        <TableHeaderColumn dataField="flight_number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.NumeroDoVoo}</TableHeaderColumn>
        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Status}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
  : 
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tituloOffLine}</h3>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.general.semDados}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='70'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Acoes}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Base}</TableHeaderColumn>
        <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="registration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Aeronave}</TableHeaderColumn>
        <TableHeaderColumn dataField="model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Frota}</TableHeaderColumn>
        <TableHeaderColumn dataField="client" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Cliente}</TableHeaderColumn>
        <TableHeaderColumn dataField="flight_type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.TipoDeVoo}</TableHeaderColumn>
        <TableHeaderColumn dataField="report_number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.NumeroDoRelatorio}</TableHeaderColumn>
        <TableHeaderColumn dataField="flight_number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.NumeroDoVoo}</TableHeaderColumn>
        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='160'>{this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Status}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
  }
</div>
    );
  }
}

export default FlightReportsIndex;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/FlightReportsIndex.js